import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Instagram, Heart } from 'lucide-react';
import { useSettings } from '../contexts/SettingsContext';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_940e8ae3-c19e-4add-8a26-04b3a3541f3d/artifacts/59pes23f_logocafe.png";

export default function Footer() {
  const { whatsappNumber, settings } = useSettings();
  const displayPhone = settings?.phone || '+57 301 228 0877';

  return (
    <footer className="bg-[#46371c] text-[#fcfbf9]" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <img src={LOGO_URL} alt="Keiks" className="h-12 w-auto brightness-200 mb-4" />
            <p className="font-body text-sm text-[#bce3cd] leading-relaxed">
              Reposteria artesanal colombiana. Creamos momentos dulces para tus celebraciones especiales.
            </p>
          </div>
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Categorias</h4>
            <ul className="space-y-2 font-body text-sm text-[#bce3cd]">
              <li><Link to="/productos?category=tortas-especiales" className="hover:text-[#a0d5ba] transition-colors">Tortas Especiales</Link></li>
              <li><Link to="/productos?category=refrigeradas" className="hover:text-[#a0d5ba] transition-colors">Refrigeradas</Link></li>
              <li><Link to="/productos?category=clasicas" className="hover:text-[#a0d5ba] transition-colors">Clasicas</Link></li>
              <li><Link to="/productos?category=saludables" className="hover:text-[#a0d5ba] transition-colors">Saludables</Link></li>
              <li><Link to="/productos?category=pide-para-hoy" className="hover:text-[#a0d5ba] transition-colors">Pide para Hoy</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Ayuda</h4>
            <ul className="space-y-2 font-body text-sm text-[#bce3cd]">
              <li><Link to="/tracking" className="hover:text-[#a0d5ba] transition-colors">Seguimiento de pedido</Link></li>
              <li><Link to="/#faq" className="hover:text-[#a0d5ba] transition-colors">Preguntas frecuentes</Link></li>
              <li><Link to="/legal?tab=terms" className="hover:text-[#a0d5ba] transition-colors">Términos y Condiciones</Link></li>
              <li><Link to="/legal?tab=privacy" className="hover:text-[#a0d5ba] transition-colors">Políticas de Privacidad</Link></li>
              <li><Link to="/legal?tab=pqrs" className="hover:text-[#a0d5ba] transition-colors">Radicar PQRS</Link></li>
              <li><a href={`https://wa.me/${whatsappNumber}`} target="_blank" rel="noopener noreferrer" className="hover:text-[#a0d5ba] transition-colors">WhatsApp</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Contacto</h4>
            <ul className="space-y-3 font-body text-sm text-[#bce3cd]">
              <li className="flex items-center gap-2"><Phone className="w-4 h-4" /> {displayPhone.startsWith('+') || displayPhone.startsWith('57') ? displayPhone : `+57 ${displayPhone}`}</li>
              <li className="flex items-center gap-2"><Mail className="w-4 h-4" /> info@keiks.com</li>
              <li className="flex items-center gap-2"><MapPin className="w-4 h-4" /> Medellin, Colombia</li>
              <li className="flex items-center gap-2">
                <Instagram className="w-4 h-4" />
                <a href="https://www.instagram.com/keiks_reposteria" target="_blank" rel="noopener noreferrer" className="hover:text-[#a0d5ba] transition-colors">
                  @keiks_reposteria
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-[#fcfbf9]/10 mt-10 pt-6 text-center font-body text-xs text-[#bce3cd]">
          &copy; {new Date().getFullYear()} Keiks Reposteria. Todos los derechos reservados | <a href="https://www.colombiaws.com" target="_blank" className='font-body text-xs text-[#bce3cd]'><span>Hecho con <Heart className='inline w-4 h-4 text-[#c56076] animate-pulse' /> por ColombiaWS.com</span></a>
        </div>
      </div>
    </footer>
  );
}
